var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressEditIcon = function SvgAddressEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M10.786 1.008a2.46 2.46 0 0 1 3.388 3.565l-8.72 8.309a.67.67 0 0 1-.46.184H2.396a.727.727 0 0 1-.727-.727v-2.26a1 1 0 0 1 .312-.726zm.26 4.705-6.318 6.02H3v-1.51l6.446-6.109zm.965-.92 1.244-1.185a1.126 1.126 0 0 0-1.552-1.633l-1.288 1.222z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M.668 15c0-.368.298-.667.667-.667h13.333a.667.667 0 0 1 0 1.334H1.335A.667.667 0 0 1 .668 15"
  })));
};
export default SvgAddressEditIcon;